import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';
import { baseURL } from '../base_url';
import { PuffLoader } from 'react-spinners';
import { Form, Col, Row } from 'react-bootstrap';
import { Button, Container } from '@mui/material';
import { FaPlus } from 'react-icons/fa';
import { MdSportsGolf } from 'react-icons/md';
import Select from "react-select";


const AddFleet = () => {
  const [loading, setLoading] = useState(false);
  const [vinNumber, setVinNumber] = useState('');
  const vinPattern = /^[A-HJ-NPR-Z0-9]{17}$/; 

  const loggedInUser = sessionStorage.getItem("tm_token");
  const foundUser = JSON.parse(loggedInUser);
  const [packOption, setPackOption] = useState(null)

  const packItems = [
      { value: 'pack_3', label: 'pack-3' },
      { value: 'pack_3_fleet_core', label: 'pack-3.FLEET_CORE' },
      { value: 'pack_3_fleet_premium', label: 'pack-3.FLEET_PREMIUM' },
  ];

  const handlePackChange = (selectedOption) => {
    setPackOption(selectedOption.value)
  }
  
  const handleSubmitForm = (e) => {
    if(vinNumber.toString().trim() === ''){
      Swal.fire({icon: 'error',
                text: 'Please enter VIN Number.'})
      return;
    }
    if(packOption.toString().trim() === ''){
      Swal.fire({icon: 'error',
                text: 'Please select pack.'})
      return;
    }
    if (!vinPattern.test(vinNumber)) {
      Swal.fire({ icon: 'error', text: 'Please enter a valid VIN Number.' });
      return;
    }
    setLoading(true);
    axios.post(baseURL + "/create_contract", {
      'vin': vinNumber.toString().trim(),
      'pack': packOption,
      'admin_id': foundUser['tm_id']
      }).then((res) => {
        setLoading(false);
        if (res.data.msg_status == 1){
          Swal.fire({icon: 'success',
            title: res.data.msg
          })
          setVinNumber('');
          setPackOption(null)
        }else{
          Swal.fire({icon: 'error',
            title: res.data.msg
          })
        }
    })
  }
  return(
    <div className='body_class'>
      {loading ? (
          <div className="loader-overlay">
              <div className="loader">
              <PuffLoader color="#00308F" loading={true} size={200} />
              </div>
          </div>
      ) : ("")}
        <div className='container-fluid'>
            <h4>Create Contract</h4>
            <div className='mt-4'>
            <div className='container-fluid'>
            <Form>
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                  <Form.Label column sm="2">
                    VIN Number *
                  </Form.Label>
                  <Col sm="5">
                    <Form.Control type='text' value={vinNumber} onChange={(e)=>setVinNumber(e.target.value)} placeholder='Enter VIN Number' />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                  <Form.Label column sm="2">
                    Pack *
                  </Form.Label>
                  <Col sm="5">
                    <Select placeholder="Select Pack" 
                      options={packItems} 
                      onChange={handlePackChange} 
                      value={packItems.find(option => option.value === packOption)}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                  <Form.Label column sm="2"></Form.Label>
                  <Col sm="5">
                  <Button variant="contained" onClick={handleSubmitForm}><FaPlus />&nbsp;Create</Button>
                  </Col>
                </Form.Group>
              </Form>
            </div>
            </div>
        </div>
    </div>
  )  
}

export default AddFleet;